import {ElectronApi} from "../util/electron/";

const setGlobal = (_window) => {
    _window.ElectronApi = ElectronApi
};

export default {
    setGlobal,
    ElectronApi
}
